import React, { useEffect, useState } from 'react'
import styles from './Announcements.module.scss';
import AnnouncementDetails from './AnnouncementDetails/AnnouncementDetails';
import Summary from './Summary/Summary';
import { useNavigate, useParams } from 'react-router-dom';
import { privateGet } from 'services/privateRequest';
import { ANNOUNCEMENT } from 'services/apiEndpoints';
import { Skeleton } from '@mui/material';



const SingleAnnouncement = () => {
    const { id } = useParams()
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            try {
                const response = await privateGet(`${ANNOUNCEMENT}/${id}`)
                if (!response) navigate(-1)
                const openedCount = response?.data?.data.recipientsStatus.filter(item => item.status === "opened").length
                setData({ ...response?.data?.data, openedCount })
                setLoading(false)
            } catch (error) {
                setLoading(false)
            }
        }
        fetchData()
    }, [])


    return (
        <>
            <div className={styles?.singleMainContainer}>
                {
                    loading ?
                        <Skeleton variant="rect" height="100%" />
                        :
                        <AnnouncementDetails data={data} />
                }
                <Summary recipientType={data?.recipientType} openedCount={data?.openedCount} data={data?.recipientsStatus} loading={loading} announcementType={data?.deliveryOptions?.notification?.sendType} />
            </div>
        </>
    )
}

export default SingleAnnouncement